import { whatIfPickUpDateOnHolidayDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getwhatIfPickUpDateOnHolidayEn = () => {
  const data = whatIfPickUpDateOnHolidayDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addwhatIfPickUpDateOnHoliday = () => {
  if (
    window.location.href.includes(
      `us/en/support/faqs/what-if-my-next-pickup-date-falls-on-a-holiday`,
    ) &&
    document.getElementById(`whatIfPickUpDateOnHolidayJSONLD`) === null
  ) {
    const script = whatIfPickUpDateOnHolidayJSONLDEn()
    addJSONLDToHead(script, `whatIfPickUpDateOnHolidayJSONLD`)
  } else {
    removeElement(`whatIfPickUpDateOnHolidayJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const whatIfPickUpDateOnHolidayJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getwhatIfPickUpDateOnHolidayEn(),
  }
  return FaqBagsterTemplate
}
